import {
    MSG_SHOW_ERROR,
    MSG_SHOW_INFO,
    MSG_SHOW_SUCCESS,
    MSG_SHOW_WARNING, 
    MSG_SHOW_WARNING_SAVE,
    MSG_CONFIRM_SHOW, 
    MSG_CONFIRM_HIDE,
    MSG_HIDE_WARNING_SAVE
} from '../../../redux/actions/actionTypes';

export const MsgBox = {
    error:function(message){
        if ((message+"").includes('Request failed with status code 401')) {
            message = 'กรุณา Login ก่อนเข้าใช้งาน '}
        window.emitter.emit(MSG_SHOW_ERROR,message); 
    },    
    success:function(message, mainscreentab){
        window.emitter.emit(MSG_SHOW_SUCCESS, message, mainscreentab);     
    },    
    warning:function(message){
        window.emitter.emit(MSG_SHOW_WARNING,message); 
    },    
    info:function(message){
        window.emitter.emit(MSG_SHOW_INFO,message);  
    },
    showConfirm:function(title,message,onOK,onCancel,onClosed){
        window.emitter.emit(MSG_CONFIRM_SHOW,title,message,onOK,onCancel,onClosed); 
    },
    hideConfirm:function(){
        window.emitter.emit(MSG_CONFIRM_HIDE)
    },
    warningSave:function(data){
        window.emitter.emit(MSG_SHOW_WARNING_SAVE,data); 
    },
    hidewarningSave:function(){
        window.emitter.emit(MSG_HIDE_WARNING_SAVE)
    }, 
}